import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

const stageConfig = {
  GTM_CONTAINER_ID: undefined,
  CONTENTFUL_SPACE_ID: "itxkjaj41rzb",
  CONTENTFUL_SPACE_TOKEN: undefined,
  CONTENTFUL_SECRET: "",
  CONTENTFUL_SPACE_ENVIRONMENT: "stage",
  CONTENTFUL_SPACE_PREVIEW_TOKEN: "",
  CONTENTFUL_MANAGEMENT_TOKEN: "",
  REVALIDATION_APP_URL: "https://prod-revalidate.no-ga.com",
  NOGA_API_ENDPOINT: "https://api2-stage.no-ga.com/api",
  ADYEN_MERCHANT_ACCOUNT: "NOGA_Commerce_ECOM",
  ELEVATE_PRODUCT_SERVICE_URL:
    "http://ngg-frontendproductapi-stage-deployment.default.svc.cluster.local:8080/api/frontend-product-api-stage",
  USE_REDIS_CACHE: undefined,
  REDIS_URL: undefined,
  REDIS_CACHE: undefined,
  REDIS_AVAILABLE: undefined,
  SERVICE_USERNAME: "nglm-graph",
  SERVICE_PASSWORD: undefined,
  CART_SERVICE_URL: "https://api2-stage.no-ga.com/cart/api",
  CART_SERVICE_USERNAME: undefined,
  CART_SERVICE_PASSWORD: undefined,
  ACCOUNT_SERVICE_URL: "https://api2-stage.no-ga.com/account",
  ACCOUNT_SERVICE_USERNAME: undefined,
  ACCOUNT_SERVICE_PASSWORD: undefined,
  CRM_SERVICE_URL: "https://api2-stage.no-ga.com/crm/api",
  CRM_SERVICE_USERNAME: undefined,
  CRM_SERVICE_PASSWORD: undefined,
  STOCK_SERVICE_URL: "https://api2-stage.no-ga.com/stock",
  STOCK_SERVICE_USERNAME: undefined,
  STOCK_SERVICE_PASSWORD: undefined,
  PRODUCT_SERVICE_URL:
    "http://fe-prodapi-stage.no-ga.com/api/frontend-product-api",
  PRODUCT_SERVICE_USERNAME: undefined,
  PRODUCT_SERVICE_PASSWORD: undefined,
  APP_BASE_DOMAIN: undefined,
  BUILD_APP_SEO: "true",
  SITEMAP_NAME: undefined,
  SITEMAP_BLOB_STORAGE: "nggfeedpublicprod",
  SITEMAP_STORAGE_GUID: "4f11811e-3cbd-4b38-a9bb-634e5f1dffb5",
  SITEMAP_APP_ENVIRONMENT: undefined,
  SITEMAP_BASE_DOMAIN: undefined,

  NEXT_PUBLIC_ENVIRONMENT: "stage",
  NEXT_PUBLIC_VOYADO_SCRIPT:
    "https://assets.voyado.com/jsfiles/analytics_0.1.7.staging.min.js",
  NEXT_PUBLIC_PROXY_AUTH_SECRET: undefined,
  NEXT_PUBLIC_SERVICE_ENDPOINT_PATH: "graphql",
  NEXT_PUBLIC_SERVICE_USER: "nglm-graph",
  NEXT_PUBLIC_SERVICE_ENDPOINT: "https://api2-stage.no-ga.com/nglm-graph/v2",
  NEXT_PUBLIC_ADYEN_CLIENT_KEY: "test_GOOOQLICJJERDETIW5FGPJCKEI5BKBXR",
  NEXT_PUBLIC_ADYEN_ENVIRONMENT: "test",
  NEXT_PUBLIC_ADYEN_RETURN_URL: "checkout/success?orderRef={ORDERREF}",
  NEXT_PUBLIC_ADYEN_PAYMENT_METHOD_ID: "14",
  NEXT_PUBLIC_WALLEY_PAYMENT_METHOD_ID: "165",
  NEXT_PUBLIC_WALLEY_RETURN_URL:
    "checkout/success?reference={checkout.publictoken}",
  NEXT_PUBLIC_WALLEY_SCRIPT_SOURCE:
    "https://api.uat.walleydev.com/walley-checkout-loader.js",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_SE: "6347",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_SE: "6348",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_NO: "6349",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_NO: "6350",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_FI: "6351",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_FI: "6352",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_DK: "6353",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_DK: "6354",
  NEXT_PUBLIC_NORCE_IMAGE_CDN: "https://cdn-stage.no-ga.com",
  NEXT_PUBLIC_NSHIFT_DYNAMIC_FREIGHT_PARTNO: "1000000",
  NEXT_PUBLIC_ELEVATE_CLUSTER_ID: "w09f88952",
  NEXT_PUBLIC_APP_PROTOCOL: "http",
  STRING_PLANNER_GUID: "sit_ODUyMDk5MjAwMA",
  NSHIFT_API_KEY_ID: "4ZDVGM27XVF7HHMF",
  NSHIFT_API_URL: "https://api.unifaun.com/rs-extapi/v1",
  REDIRECT_ENGINE_ENABLED: "true",
  NEXT_PUBLIC_GIFT_CARD_PAYMENT_METHOD_ID: "87",
  NEXT_PUBLIC_BRAND: "noga",
  NEXT_PUBLIC_WALLEY_CHANNEL_VARIANT: "stage-ng3",

  NEXT_PUBLIC_FEATURES_SEARCH_ENGINE_EXPLODE_PRODUCTS: "true",
  NEXT_PUBLIC_FEATURES_CACHE_LOOP: "true",
  NEXT_PUBLIC_FEATURES_NEW_MARKET_SELECTOR: "false",
  NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_IMBOX_BUTTON: "true",
  NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_EMAIL_LINK: "true",
  NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_PHONE_LINK: "true",
  NEXT_PUBLIC_FEATURES_PRODUCTS_SWATCHES: "false",
  NEXT_PUBLIC_FEATURES_PRODUCTS_VIDEOS: "true",
  NEXT_PUBLIC_FEATURES_SHOW_DISCOUNT_POPUP: "true",
  NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS: "true",
  NEXT_PUBLIC_FEATURES_STATIC_PRODUCT_PAGES: "false",
  NEXT_PUBLIC_FEATURES_EXPONENTIAL_PRICE_FILTER: "false",
  NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS_CHANGE_BUTTON: "false",
  NEXT_PUBLIC_FEATURES_CHECKOUT_MADE_TO_ORDER: "false",
  NEXT_PUBLIC_FEATURES_CHECKOUT_ADYEN: "true",
  NEXT_PUBLIC_FEATURES_CHECKOUT_WALLEY: "true",
  NEXT_PUBLIC_FEATURES_CART_WALLEY_WIDGET: "true",
  NEXT_PUBLIC_FEATURES_CHECKOUT_V2: "true",
  NEXT_PUBLIC_FEATURES_CHECKOUT_V3: "false",
  NEXT_PUBLIC_FEATURES_PRODUCT_NEW_PRODUCT_PAGE: "false",
  NEXT_PUBLIC_FEATURES_PRODUCT_CONTENTFUL_PARAMETRICS: "true",
  NEXT_PUBLIC_FEATURES_GOOGLE_AUTOMATED_DISCOUNTS: "true",
  NEXT_PUBLIC_FEATURES_LINK_PREFETCH: "true",
  NEXT_PUBLIC_FEATURES_ELEVATE: "true",
  NEXT_PUBLIC_FEATURES_EUROBONUS: "false",
  NEXT_PUBLIC_FEATURES_DYNAMIC_PLP: "true",
  NEXT_PUBLIC_FEATURES_IMBOX: "true",
  NEXT_PUBLIC_FEATURES_VOYADO_ONSITE: "true",
  NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE: "true",
  NEXT_PUBLIC_FEATURES_PRODUCTS_V2_IMAGES: "true",
  NEXT_PUBLIC_FEATURES_STORE_LOCATOR: "true",
  NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE_SHORTCUT: "true",
  NEXT_PUBLIC_FEATURES_PRODUCT_NEW_GALLERY: "true",

  // market specific
  NEXT_PUBLIC_APP_MARKET: undefined,
  NEXT_PUBLIC_APP_BASE_URL: undefined,
  NEXT_PUBLIC_APP_LANGUAGE: undefined,
  HREFLANG_ENABLED: undefined,
};

const preprodConfig = {
  NEXT_PUBLIC_FEATURES_VOYADO_ONSITE: "true",
};

const prodConfig = {
  NEXT_PUBLIC_ENVIRONMENT: "prod",
  CONTENTFUL_SPACE_ENVIRONMENT: "master",
  CART_SERVICE_URL: "https://api2.no-ga.com/cart/api",
  ACCOUNT_SERVICE_URL: "https://api2.no-ga.com/account",
  CRM_SERVICE_URL: "https://api2.no-ga.com/crm/api",
  STOCK_SERVICE_URL: "https://api2.no-ga.com/stock",
  NOGA_API_ENDPOINT: "https://api2.no-ga.com/api",
  PRODUCT_SERVICE_URL:
    "http://fe-prodapi-prod.no-ga.com/api/frontend-product-api",
  ELEVATE_PRODUCT_SERVICE_URL:
    "http://ngg-frontendproductapi-deployment.default.svc.cluster.local:8080/api/frontend-product-api",
  NEXT_PUBLIC_VOYADO_SCRIPT:
    "https://assets.voyado.com/jsfiles/analytics_0.1.7.min.js",
  NEXT_PUBLIC_SERVICE_ENDPOINT: "https://api2.no-ga.com/nglm-graph/v2",
  NEXT_PUBLIC_NORCE_IMAGE_CDN: "https://noga.cdn-norce.tech",
  NEXT_PUBLIC_ELEVATE_CLUSTER_ID: "wDFDC3287",
  NEXT_PUBLIC_ADYEN_CLIENT_KEY: "live_L6JMMVBS5JGUVM6E45K3GCWUKI7IKMYC",
  NEXT_PUBLIC_ADYEN_ENVIRONMENT: "live",
  NEXT_PUBLIC_WALLEY_SCRIPT_SOURCE:
    "https://api.walleypay.com/walley-checkout-loader.js",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_SE: "11444",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_SE: "11445",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_NO: "11446",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_NO: "11447",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_FI: "11448",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_FI: "11449",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_DK: "11450",
  NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_DK: "11451",
  NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS: "false",
  NEXT_PUBLIC_FEATURES_CART_WALLEY_WIDGET: "false",
  NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE: "false",
  NEXT_PUBLIC_FEATURES_VOYADO_ONSITE: "false",
  NEXT_PUBLIC_FEATURES_LINK_PREFETCH: "false",
  NEXT_PUBLIC_FEATURES_STORE_LOCATOR: "true",
  NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE_SHORTCUT: "true",
  NEXT_PUBLIC_WALLEY_CHANNEL_VARIANT: "prod",
};

const currentEnvironment = process.env.NEXT_PUBLIC_ENVIRONMENT ?? "stage";
const currentMarket = (process.env.NEXT_PUBLIC_APP_MARKET ?? "").toLowerCase();

function getConfig(env = currentEnvironment) {
  switch (env) {
    case "local":
      return {
        ...stageConfig,
        NEXT_PUBLIC_SERVICE_ENDPOINT: "http://localhost:4501/nglm-graph/v2",
        NEXT_PUBLIC_NSHIFT_DYNAMIC_FREIGHT_PARTNO: "1000027",
      };
    case "preprod":
      return { ...stageConfig, ...prodConfig, ...preprodConfig };
    case "prod":
      return { ...stageConfig, ...prodConfig };
    default:
      return stageConfig;
  }
}

function marketFields(market, baseUrls) {
  const code = market === "se" || market === "no" ? market : "de";
  return {
    NEXT_PUBLIC_APP_MARKET: code,
    NEXT_PUBLIC_APP_BASE_URL: baseUrls[code],
    NEXT_PUBLIC_APP_LANGUAGE:
      code === "se" ? "sv" : code === "no" ? "nb" : "en",
    SITEMAP_BASE_DOMAIN: code === "de" ? undefined : "nordiska",
    APP_BASE_DOMAIN:
      code === "se"
        ? "www.nordiskagalleriet.se"
        : code === "no"
          ? "www.nordiskagalleriet.no"
          : "www.no-ga.com",
    HREFLANG_ENABLED: code === "de" ? "true" : "false",
  };
}

function getMarketSpecificConfig(
  env = currentEnvironment,
  market = currentMarket,
) {
  switch (env) {
    case "preprod":
      return marketFields(market, {
        se: "https://se-preprod.no-ga.com",
        no: "https://no-preprod.no-ga.com",
        de: "https://preprod.no-ga.com",
      });
    case "prod":
      return marketFields(market, {
        se: "https://www.nordiskagalleriet.se",
        no: "https://www.nordiskagalleriet.no",
        de: "https://www.no-ga.com",
      });
    case "local":
    case "dev":
    case "stage":
    default:
      return marketFields(market, {
        se: "https://se-stage.no-ga.com",
        no: "https://no-stage.no-ga.com",
        de: "https://stage.no-ga.com",
      });
  }
}

function getGtmContainerId(env = currentEnvironment) {
  if (env === "prod") return "GTM-TQMP4JN";
  if (env === "stage" || env === "preprod") return "GTM-NPN3HF89";
  return undefined;
}

function getSitemapName(env = currentEnvironment) {
  if (env === "local") return "localhost";
  if (env === "preprod") return "preprod";
  return "noga";
}

function getAppProtocol(env = currentEnvironment) {
  if (process.env.NEXT_PUBLIC_APP_PROTOCOL) {
    return process.env.NEXT_PUBLIC_APP_PROTOCOL;
  }
  return env === "local" ? "http" : "https";
}

export const env = createEnv({
  /**
   * Specify your server-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars.
   */
  server: {
    NODE_ENV: z
      .enum(["development", "test", "production"])
      .default("development"),
    GTM_CONTAINER_ID: z.string().optional(),
    CONTENTFUL_SPACE_ID: z.string().default("itxkjaj41rzb"),
    CONTENTFUL_SPACE_TOKEN: z.string(),
    CONTENTFUL_SECRET: z.string().optional().default(""),
    CONTENTFUL_SPACE_ENVIRONMENT: z.string().default("master"),
    CONTENTFUL_SPACE_PREVIEW_TOKEN: z.string().optional().default(""),
    CONTENTFUL_MANAGEMENT_TOKEN: z.string().optional().default(""),
    REVALIDATION_APP_URL: z.string().optional(),
    NOGA_API_ENDPOINT: z.string(),
    ADYEN_MERCHANT_ACCOUNT: z.string().optional(),
    ELEVATE_PRODUCT_SERVICE_URL: z.string().optional(),
    USE_REDIS_CACHE: z.string().optional(),
    REDIS_URL: z.string().optional(),
    REDIS_CACHE: z.string().optional(),
    REDIS_AVAILABLE: z.string().optional(),
    PROXY_AUTH_SECRET: z.string().optional(),

    // TEMP
    SERVICE_USERNAME: z.string().optional(),
    SERVICE_PASSWORD: z.string().optional(),
    CART_SERVICE_URL: z.string(),
    CART_SERVICE_USERNAME: z.string().optional(),
    CART_SERVICE_PASSWORD: z.string().optional(),
    ACCOUNT_SERVICE_URL: z.string(),
    ACCOUNT_SERVICE_USERNAME: z.string().optional(),
    ACCOUNT_SERVICE_PASSWORD: z.string().optional(),
    CRM_SERVICE_URL: z.string(),
    CRM_SERVICE_USERNAME: z.string().optional(),
    CRM_SERVICE_PASSWORD: z.string().optional(),
    STOCK_SERVICE_URL: z.string(),
    STOCK_SERVICE_USERNAME: z.string().optional(),
    STOCK_SERVICE_PASSWORD: z.string().optional(),
    PRODUCT_SERVICE_URL: z.string().optional(),
    PRODUCT_SERVICE_USERNAME: z.string().optional(),
    PRODUCT_SERVICE_PASSWORD: z.string().optional(),

    // NOT SURE
    APP_BASE_DOMAIN: z.string().optional(),
    BUILD_APP_SEO: z.string().optional(),
    SITEMAP_NAME: z.string().optional(),
    SITEMAP_BLOB_STORAGE: z.string().optional(),
    SITEMAP_STORAGE_GUID: z.string().optional(),
    SITEMAP_APP_ENVIRONMENT: z.string().optional(),
    SITEMAP_BASE_DOMAIN: z.string().optional(),
    HREFLANG_ENABLED: z.string().optional(),
    STRING_PLANNER_GUID: z.string().optional(),
    NSHIFT_API_KEY_ID: z.string().optional(),
    NSHIFT_API_URL: z.string().optional(),
    REDIRECT_ENGINE_ENABLED: z.string().optional(),
  },

  /**
   * Specify your client-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars. To expose them to the client, prefix them with
   * `NEXT_PUBLIC_`.
   */
  client: {
    NEXT_PUBLIC_ENVIRONMENT: z.enum(["local", "stage", "preprod", "prod"]),
    NEXT_PUBLIC_VOYADO_SCRIPT: z.string().optional(),
    NEXT_PUBLIC_PROXY_AUTH_SECRET: z.string().optional(),
    NEXT_PUBLIC_SERVICE_ENDPOINT_PATH: z.string(),
    NEXT_PUBLIC_SERVICE_USER: z.string(),
    NEXT_PUBLIC_SERVICE_ENDPOINT: z.string(),
    NEXT_PUBLIC_ADYEN_CLIENT_KEY: z.string().optional(),
    NEXT_PUBLIC_ADYEN_ENVIRONMENT: z.string().optional(),
    NEXT_PUBLIC_ADYEN_RETURN_URL: z.string().optional(),
    NEXT_PUBLIC_ADYEN_PAYMENT_METHOD_ID: z.string().optional(),
    NEXT_PUBLIC_WALLEY_PAYMENT_METHOD_ID: z.string().optional(),
    NEXT_PUBLIC_WALLEY_RETURN_URL: z.string().optional(),
    NEXT_PUBLIC_WALLEY_SCRIPT_SOURCE: z.string().optional(),
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_SE: z.coerce.number(),
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_SE: z.coerce.number(),
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_NO: z.coerce.number(),
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_NO: z.coerce.number(),
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_FI: z.coerce.number(),
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_FI: z.coerce.number(),
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_DK: z.coerce.number(),
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_DK: z.coerce.number(),
    NEXT_PUBLIC_WALLEY_CHANNEL_VARIANT: z.string().optional(),
    NEXT_PUBLIC_NORCE_IMAGE_CDN: z.string(),
    NEXT_PUBLIC_NSHIFT_DYNAMIC_FREIGHT_PARTNO: z.string().optional(),
    NEXT_PUBLIC_ELEVATE_CLUSTER_ID: z.string(),
    NEXT_PUBLIC_BRAND: z.string().optional(),
    NEXT_PUBLIC_APP_MARKET: z.string(),
    NEXT_PUBLIC_APP_BASE_URL: z.string(),
    NEXT_PUBLIC_APP_LANGUAGE: z.string(),
    NEXT_PUBLIC_APP_PROTOCOL: z.string(),
    NEXT_PUBLIC_GIFT_CARD_PAYMENT_METHOD_ID: z.string().optional(),
    NEXT_PUBLIC_FEATURES_NEW_MARKET_SELECTOR: z.string().optional(),
    NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_IMBOX_BUTTON: z.string().optional(),
    NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_EMAIL_LINK: z.string().optional(),
    NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_PHONE_LINK: z.string().optional(),
    NEXT_PUBLIC_FEATURES_PRODUCTS_SWATCHES: z.string().optional(),
    NEXT_PUBLIC_FEATURES_PRODUCTS_VIDEOS: z.string().optional(),
    NEXT_PUBLIC_FEATURES_SHOW_DISCOUNT_POPUP: z.string().optional(),
    NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS: z.string().optional(),
    NEXT_PUBLIC_FEATURES_STATIC_PRODUCT_PAGES: z.string().optional(),
    NEXT_PUBLIC_FEATURES_EXPONENTIAL_PRICE_FILTER: z.string().optional(),
    NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS_CHANGE_BUTTON: z
      .string()
      .optional(),
    NEXT_PUBLIC_FEATURES_CHECKOUT_MADE_TO_ORDER: z.string().optional(),
    NEXT_PUBLIC_FEATURES_CHECKOUT_ADYEN: z.string().optional(),
    NEXT_PUBLIC_FEATURES_CHECKOUT_WALLEY: z.string().optional(),
    NEXT_PUBLIC_FEATURES_CART_WALLEY_WIDGET: z.string().optional(),
    NEXT_PUBLIC_FEATURES_CHECKOUT_V2: z.string().optional(),
    NEXT_PUBLIC_FEATURES_CHECKOUT_V3: z.string().optional(),
    NEXT_PUBLIC_FEATURES_PRODUCT_NEW_PRODUCT_PAGE: z.string().optional(),
    NEXT_PUBLIC_FEATURES_PRODUCT_CONTENTFUL_PARAMETRICS: z.string().optional(),
    NEXT_PUBLIC_FEATURES_GOOGLE_AUTOMATED_DISCOUNTS: z.string().optional(),
    NEXT_PUBLIC_FEATURES_LINK_PREFETCH: z.string().optional(),
    NEXT_PUBLIC_FEATURES_ELEVATE: z.string().optional(),
    NEXT_PUBLIC_FEATURES_EUROBONUS: z.string().optional(),
    NEXT_PUBLIC_FEATURES_DYNAMIC_PLP: z.string().optional(),
    NEXT_PUBLIC_FEATURES_IMBOX: z.string().optional(),
    NEXT_PUBLIC_FEATURES_VOYADO_ONSITE: z.string().optional(),
    NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE: z.string().optional(),
    NEXT_PUBLIC_FEATURES_PRODUCTS_V2_IMAGES: z.string().optional(),
    NEXT_PUBLIC_FEATURES_STORE_LOCATOR: z.string().optional(),
    NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE_SHORTCUT: z.string().optional(),
    NEXT_PUBLIC_FEATURES_PRODUCT_NEW_GALLERY: z.string().optional(),
  },

  /**
   * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
   * middlewares) or client-side so we need to destruct manually.
   */
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV ?? "development",
    NEXT_PUBLIC_ENVIRONMENT: currentEnvironment,

    GTM_CONTAINER_ID:
      process.env.GTM_CONTAINER_ID ?? getGtmContainerId(currentEnvironment),
    CONTENTFUL_SPACE_ID:
      process.env.CONTENTFUL_SPACE_ID ??
      getConfig(currentEnvironment).CONTENTFUL_SPACE_ID,
    CONTENTFUL_SPACE_TOKEN:
      process.env.CONTENTFUL_SPACE_TOKEN ??
      getConfig(currentEnvironment).CONTENTFUL_SPACE_TOKEN,
    CONTENTFUL_SECRET:
      process.env.CONTENTFUL_SECRET ??
      getConfig(currentEnvironment).CONTENTFUL_SECRET,
    CONTENTFUL_SPACE_ENVIRONMENT:
      process.env.CONTENTFUL_SPACE_ENVIRONMENT ??
      getConfig(currentEnvironment).CONTENTFUL_SPACE_ENVIRONMENT,
    CONTENTFUL_SPACE_PREVIEW_TOKEN:
      process.env.CONTENTFUL_SPACE_PREVIEW_TOKEN ??
      getConfig(currentEnvironment).CONTENTFUL_SPACE_PREVIEW_TOKEN,
    CONTENTFUL_MANAGEMENT_TOKEN:
      process.env.CONTENTFUL_MANAGEMENT_TOKEN ??
      getConfig(currentEnvironment).CONTENTFUL_MANAGEMENT_TOKEN,
    REVALIDATION_APP_URL:
      process.env.REVALIDATION_APP_URL ??
      getConfig(currentEnvironment).REVALIDATION_APP_URL,
    NOGA_API_ENDPOINT:
      process.env.NOGA_API_ENDPOINT ??
      getConfig(currentEnvironment).NOGA_API_ENDPOINT,
    ADYEN_MERCHANT_ACCOUNT:
      process.env.ADYEN_MERCHANT_ACCOUNT ??
      getConfig(currentEnvironment).ADYEN_MERCHANT_ACCOUNT,
    ELEVATE_PRODUCT_SERVICE_URL:
      process.env.ELEVATE_PRODUCT_SERVICE_URL ??
      getConfig(currentEnvironment).ELEVATE_PRODUCT_SERVICE_URL,
    USE_REDIS_CACHE:
      process.env.USE_REDIS_CACHE ??
      getConfig(currentEnvironment).USE_REDIS_CACHE,
    REDIS_URL: process.env.REDIS_URL ?? getConfig(currentEnvironment).REDIS_URL,
    REDIS_CACHE:
      process.env.REDIS_CACHE ?? getConfig(currentEnvironment).REDIS_CACHE,
    REDIS_AVAILABLE:
      process.env.REDIS_AVAILABLE ??
      getConfig(currentEnvironment).REDIS_AVAILABLE,
    PROXY_AUTH_SECRET:
      process.env.PROXY_AUTH_SECRET ??
      process.env.NEXT_PUBLIC_PROXY_AUTH_SECRET ??
      getConfig(currentEnvironment).NEXT_PUBLIC_PROXY_AUTH_SECRET,
    SERVICE_USERNAME:
      process.env.SERVICE_USERNAME ??
      getConfig(currentEnvironment).SERVICE_USERNAME,
    SERVICE_PASSWORD:
      process.env.SERVICE_PASSWORD ??
      getConfig(currentEnvironment).SERVICE_PASSWORD,
    CART_SERVICE_URL:
      process.env.CART_SERVICE_URL ??
      getConfig(currentEnvironment).CART_SERVICE_URL,
    CART_SERVICE_USERNAME:
      process.env.CART_SERVICE_USERNAME ??
      getConfig(currentEnvironment).CART_SERVICE_USERNAME,
    CART_SERVICE_PASSWORD:
      process.env.CART_SERVICE_PASSWORD ??
      getConfig(currentEnvironment).CART_SERVICE_PASSWORD,
    ACCOUNT_SERVICE_URL:
      process.env.ACCOUNT_SERVICE_URL ??
      getConfig(currentEnvironment).ACCOUNT_SERVICE_URL,
    ACCOUNT_SERVICE_USERNAME:
      process.env.ACCOUNT_SERVICE_USERNAME ??
      getConfig(currentEnvironment).ACCOUNT_SERVICE_USERNAME,
    ACCOUNT_SERVICE_PASSWORD:
      process.env.ACCOUNT_SERVICE_PASSWORD ??
      getConfig(currentEnvironment).ACCOUNT_SERVICE_PASSWORD,
    CRM_SERVICE_URL:
      process.env.CRM_SERVICE_URL ??
      getConfig(currentEnvironment).CRM_SERVICE_URL,
    CRM_SERVICE_USERNAME:
      process.env.CRM_SERVICE_USERNAME ??
      getConfig(currentEnvironment).CRM_SERVICE_USERNAME,
    CRM_SERVICE_PASSWORD:
      process.env.CRM_SERVICE_PASSWORD ??
      getConfig(currentEnvironment).CRM_SERVICE_PASSWORD,
    STOCK_SERVICE_URL:
      process.env.STOCK_SERVICE_URL ??
      getConfig(currentEnvironment).STOCK_SERVICE_URL,
    STOCK_SERVICE_USERNAME:
      process.env.STOCK_SERVICE_USERNAME ??
      getConfig(currentEnvironment).STOCK_SERVICE_USERNAME,
    STOCK_SERVICE_PASSWORD:
      process.env.STOCK_SERVICE_PASSWORD ??
      getConfig(currentEnvironment).STOCK_SERVICE_PASSWORD,
    PRODUCT_SERVICE_URL:
      process.env.PRODUCT_SERVICE_URL ??
      getConfig(currentEnvironment).PRODUCT_SERVICE_URL,
    PRODUCT_SERVICE_USERNAME:
      process.env.PRODUCT_SERVICE_USERNAME ??
      getConfig(currentEnvironment).PRODUCT_SERVICE_USERNAME,
    PRODUCT_SERVICE_PASSWORD:
      process.env.PRODUCT_SERVICE_PASSWORD ??
      getConfig(currentEnvironment).PRODUCT_SERVICE_PASSWORD,
    APP_BASE_DOMAIN:
      process.env.APP_BASE_DOMAIN ??
      getMarketSpecificConfig(currentEnvironment, currentMarket)
        .APP_BASE_DOMAIN,
    BUILD_APP_SEO:
      process.env.BUILD_APP_SEO ?? getConfig(currentEnvironment).BUILD_APP_SEO,
    SITEMAP_NAME:
      process.env.SITEMAP_NAME ?? getSitemapName(currentEnvironment),
    SITEMAP_BLOB_STORAGE:
      process.env.SITEMAP_BLOB_STORAGE ??
      getConfig(currentEnvironment).SITEMAP_BLOB_STORAGE,
    SITEMAP_STORAGE_GUID:
      process.env.SITEMAP_STORAGE_GUID ??
      getConfig(currentEnvironment).SITEMAP_STORAGE_GUID,
    SITEMAP_APP_ENVIRONMENT:
      process.env.SITEMAP_APP_ENVIRONMENT ?? currentEnvironment,
    SITEMAP_BASE_DOMAIN:
      process.env.SITEMAP_BASE_DOMAIN ??
      getMarketSpecificConfig(currentEnvironment, currentMarket)
        .SITEMAP_BASE_DOMAIN,
    HREFLANG_ENABLED:
      process.env.HREFLANG_ENABLED ??
      getMarketSpecificConfig(currentEnvironment, currentMarket)
        .HREFLANG_ENABLED,

    NEXT_PUBLIC_VOYADO_SCRIPT:
      process.env.NEXT_PUBLIC_VOYADO_SCRIPT ??
      getConfig(currentEnvironment).NEXT_PUBLIC_VOYADO_SCRIPT,
    NEXT_PUBLIC_PROXY_AUTH_SECRET:
      process.env.NEXT_PUBLIC_PROXY_AUTH_SECRET ??
      getConfig(currentEnvironment).NEXT_PUBLIC_PROXY_AUTH_SECRET,
    NEXT_PUBLIC_SERVICE_ENDPOINT_PATH:
      process.env.NEXT_PUBLIC_SERVICE_ENDPOINT_PATH ??
      getConfig(currentEnvironment).NEXT_PUBLIC_SERVICE_ENDPOINT_PATH,
    NEXT_PUBLIC_SERVICE_USER:
      process.env.NEXT_PUBLIC_SERVICE_USER ??
      getConfig(currentEnvironment).NEXT_PUBLIC_SERVICE_USER,
    NEXT_PUBLIC_SERVICE_ENDPOINT:
      process.env.NEXT_PUBLIC_SERVICE_ENDPOINT ??
      getConfig(currentEnvironment).NEXT_PUBLIC_SERVICE_ENDPOINT,
    NEXT_PUBLIC_ADYEN_CLIENT_KEY:
      process.env.NEXT_PUBLIC_ADYEN_CLIENT_KEY ??
      getConfig(currentEnvironment).NEXT_PUBLIC_ADYEN_CLIENT_KEY,
    NEXT_PUBLIC_ADYEN_ENVIRONMENT:
      process.env.NEXT_PUBLIC_ADYEN_ENVIRONMENT ??
      getConfig(currentEnvironment).NEXT_PUBLIC_ADYEN_ENVIRONMENT,
    NEXT_PUBLIC_ADYEN_RETURN_URL:
      process.env.NEXT_PUBLIC_ADYEN_RETURN_URL ??
      getConfig(currentEnvironment).NEXT_PUBLIC_ADYEN_RETURN_URL,
    NEXT_PUBLIC_ADYEN_PAYMENT_METHOD_ID:
      process.env.NEXT_PUBLIC_ADYEN_PAYMENT_METHOD_ID ??
      getConfig(currentEnvironment).NEXT_PUBLIC_ADYEN_PAYMENT_METHOD_ID,
    NEXT_PUBLIC_WALLEY_PAYMENT_METHOD_ID:
      process.env.NEXT_PUBLIC_WALLEY_PAYMENT_METHOD_ID ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_PAYMENT_METHOD_ID,
    NEXT_PUBLIC_WALLEY_RETURN_URL:
      process.env.NEXT_PUBLIC_WALLEY_RETURN_URL ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_RETURN_URL,
    NEXT_PUBLIC_WALLEY_SCRIPT_SOURCE:
      process.env.NEXT_PUBLIC_WALLEY_SCRIPT_SOURCE ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_SCRIPT_SOURCE,
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_SE:
      process.env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_SE ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_SE,
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_SE:
      process.env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_SE ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_SE,
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_NO:
      process.env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_NO ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_NO,
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_NO:
      process.env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_NO ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_NO,
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_FI:
      process.env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_FI ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_FI,
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_FI:
      process.env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_FI ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_FI,
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_DK:
      process.env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_DK ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_STORE_CODE_B2C_DK,
    NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_DK:
      process.env.NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_DK ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_STORE_CODE_B2B_DK,
    NEXT_PUBLIC_WALLEY_CHANNEL_VARIANT:
      process.env.NEXT_PUBLIC_WALLEY_CHANNEL_VARIANT ??
      getConfig(currentEnvironment).NEXT_PUBLIC_WALLEY_CHANNEL_VARIANT,
    NEXT_PUBLIC_NORCE_IMAGE_CDN:
      process.env.NEXT_PUBLIC_NORCE_IMAGE_CDN ??
      getConfig(currentEnvironment).NEXT_PUBLIC_NORCE_IMAGE_CDN,
    NEXT_PUBLIC_NSHIFT_DYNAMIC_FREIGHT_PARTNO:
      process.env.NEXT_PUBLIC_NSHIFT_DYNAMIC_FREIGHT_PARTNO ??
      getConfig(currentEnvironment).NEXT_PUBLIC_NSHIFT_DYNAMIC_FREIGHT_PARTNO,
    NEXT_PUBLIC_ELEVATE_CLUSTER_ID:
      process.env.NEXT_PUBLIC_ELEVATE_CLUSTER_ID ??
      getConfig(currentEnvironment).NEXT_PUBLIC_ELEVATE_CLUSTER_ID,
    NEXT_PUBLIC_BRAND:
      process.env.NEXT_PUBLIC_BRAND ??
      getConfig(currentEnvironment).NEXT_PUBLIC_BRAND,
    NEXT_PUBLIC_APP_MARKET:
      currentMarket ||
      getMarketSpecificConfig(currentEnvironment, currentMarket)
        .NEXT_PUBLIC_APP_MARKET,
    NEXT_PUBLIC_APP_BASE_URL:
      process.env.NEXT_PUBLIC_APP_BASE_URL ??
      getMarketSpecificConfig(currentEnvironment, currentMarket)
        .NEXT_PUBLIC_APP_BASE_URL,
    NEXT_PUBLIC_APP_LANGUAGE:
      process.env.NEXT_PUBLIC_APP_LANGUAGE ??
      getMarketSpecificConfig(currentEnvironment, currentMarket)
        .NEXT_PUBLIC_APP_LANGUAGE,
    NEXT_PUBLIC_APP_PROTOCOL: getAppProtocol(currentEnvironment),
    STRING_PLANNER_GUID:
      process.env.STRING_PLANNER_GUID ??
      getConfig(currentEnvironment).STRING_PLANNER_GUID,
    NSHIFT_API_KEY_ID:
      process.env.NSHIFT_API_KEY_ID ??
      getConfig(currentEnvironment).NSHIFT_API_KEY_ID,
    NSHIFT_API_URL:
      process.env.NSHIFT_API_URL ??
      getConfig(currentEnvironment).NSHIFT_API_URL,
    REDIRECT_ENGINE_ENABLED:
      process.env.REDIRECT_ENGINE_ENABLED ??
      getConfig(currentEnvironment).REDIRECT_ENGINE_ENABLED,
    NEXT_PUBLIC_GIFT_CARD_PAYMENT_METHOD_ID:
      process.env.NEXT_PUBLIC_GIFT_CARD_PAYMENT_METHOD_ID ??
      getConfig(currentEnvironment).NEXT_PUBLIC_GIFT_CARD_PAYMENT_METHOD_ID,
    NEXT_PUBLIC_FEATURES_NEW_MARKET_SELECTOR:
      process.env.NEXT_PUBLIC_FEATURES_NEW_MARKET_SELECTOR ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_NEW_MARKET_SELECTOR,
    NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_IMBOX_BUTTON:
      process.env.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_IMBOX_BUTTON ??
      getConfig(currentEnvironment)
        .NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_IMBOX_BUTTON,
    NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_EMAIL_LINK:
      process.env.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_EMAIL_LINK ??
      getConfig(currentEnvironment)
        .NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_EMAIL_LINK,
    NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_PHONE_LINK:
      process.env.NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_PHONE_LINK ??
      getConfig(currentEnvironment)
        .NEXT_PUBLIC_FEATURES_CUSTOMER_SERVICE_PHONE_LINK,
    NEXT_PUBLIC_FEATURES_PRODUCTS_SWATCHES:
      process.env.NEXT_PUBLIC_FEATURES_PRODUCTS_SWATCHES ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_PRODUCTS_SWATCHES,
    NEXT_PUBLIC_FEATURES_PRODUCTS_VIDEOS:
      process.env.NEXT_PUBLIC_FEATURES_PRODUCTS_VIDEOS ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_PRODUCTS_VIDEOS,
    NEXT_PUBLIC_FEATURES_SHOW_DISCOUNT_POPUP:
      process.env.NEXT_PUBLIC_FEATURES_SHOW_DISCOUNT_POPUP ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_SHOW_DISCOUNT_POPUP,
    NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS:
      process.env.NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS,
    NEXT_PUBLIC_FEATURES_STATIC_PRODUCT_PAGES:
      process.env.NEXT_PUBLIC_FEATURES_STATIC_PRODUCT_PAGES ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_STATIC_PRODUCT_PAGES,
    NEXT_PUBLIC_FEATURES_EXPONENTIAL_PRICE_FILTER:
      process.env.NEXT_PUBLIC_FEATURES_EXPONENTIAL_PRICE_FILTER ??
      getConfig(currentEnvironment)
        .NEXT_PUBLIC_FEATURES_EXPONENTIAL_PRICE_FILTER,
    NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS_CHANGE_BUTTON:
      process.env.NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS_CHANGE_BUTTON ??
      getConfig(currentEnvironment)
        .NEXT_PUBLIC_FEATURES_CHECKOUT_GIFTCARDS_CHANGE_BUTTON,
    NEXT_PUBLIC_FEATURES_CHECKOUT_MADE_TO_ORDER:
      process.env.NEXT_PUBLIC_FEATURES_CHECKOUT_MADE_TO_ORDER ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_CHECKOUT_MADE_TO_ORDER,
    NEXT_PUBLIC_FEATURES_CHECKOUT_ADYEN:
      process.env.NEXT_PUBLIC_FEATURES_CHECKOUT_ADYEN ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_CHECKOUT_ADYEN,
    NEXT_PUBLIC_FEATURES_CHECKOUT_WALLEY:
      process.env.NEXT_PUBLIC_FEATURES_CHECKOUT_WALLEY ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_CHECKOUT_WALLEY,
    NEXT_PUBLIC_FEATURES_CART_WALLEY_WIDGET:
      process.env.NEXT_PUBLIC_FEATURES_CART_WALLEY_WIDGET ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_CART_WALLEY_WIDGET,
    NEXT_PUBLIC_FEATURES_CHECKOUT_V2:
      process.env.NEXT_PUBLIC_FEATURES_CHECKOUT_V2 ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_CHECKOUT_V2,
    NEXT_PUBLIC_FEATURES_CHECKOUT_V3:
      process.env.NEXT_PUBLIC_FEATURES_CHECKOUT_V3 ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_CHECKOUT_V3,
    NEXT_PUBLIC_FEATURES_PRODUCT_NEW_PRODUCT_PAGE:
      process.env.NEXT_PUBLIC_FEATURES_PRODUCT_NEW_PRODUCT_PAGE ??
      getConfig(currentEnvironment)
        .NEXT_PUBLIC_FEATURES_PRODUCT_NEW_PRODUCT_PAGE,
    NEXT_PUBLIC_FEATURES_PRODUCT_CONTENTFUL_PARAMETRICS:
      process.env.NEXT_PUBLIC_FEATURES_PRODUCT_CONTENTFUL_PARAMETRICS ??
      getConfig(currentEnvironment)
        .NEXT_PUBLIC_FEATURES_PRODUCT_CONTENTFUL_PARAMETRICS,
    NEXT_PUBLIC_FEATURES_GOOGLE_AUTOMATED_DISCOUNTS:
      process.env.NEXT_PUBLIC_FEATURES_GOOGLE_AUTOMATED_DISCOUNTS ??
      getConfig(currentEnvironment)
        .NEXT_PUBLIC_FEATURES_GOOGLE_AUTOMATED_DISCOUNTS,
    NEXT_PUBLIC_FEATURES_LINK_PREFETCH:
      process.env.NEXT_PUBLIC_FEATURES_LINK_PREFETCH ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_LINK_PREFETCH,
    NEXT_PUBLIC_FEATURES_ELEVATE:
      process.env.NEXT_PUBLIC_FEATURES_ELEVATE ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_ELEVATE,
    NEXT_PUBLIC_FEATURES_EUROBONUS:
      process.env.NEXT_PUBLIC_FEATURES_EUROBONUS ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_EUROBONUS,
    NEXT_PUBLIC_FEATURES_DYNAMIC_PLP:
      process.env.NEXT_PUBLIC_FEATURES_DYNAMIC_PLP ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_DYNAMIC_PLP,
    NEXT_PUBLIC_FEATURES_IMBOX:
      process.env.NEXT_PUBLIC_FEATURES_IMBOX ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_IMBOX,
    NEXT_PUBLIC_FEATURES_VOYADO_ONSITE:
      process.env.NEXT_PUBLIC_FEATURES_VOYADO_ONSITE ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_VOYADO_ONSITE,
    NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE:
      process.env.NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE,
    NEXT_PUBLIC_FEATURES_PRODUCTS_V2_IMAGES:
      process.env.NEXT_PUBLIC_FEATURES_PRODUCTS_V2_IMAGES ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_PRODUCTS_V2_IMAGES,
    NEXT_PUBLIC_FEATURES_STORE_LOCATOR:
      process.env.NEXT_PUBLIC_FEATURES_STORE_LOCATOR ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_STORE_LOCATOR,
    NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE_SHORTCUT:
      process.env.NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE_SHORTCUT ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_FABRIC_SAMPLE_SHORTCUT,
    NEXT_PUBLIC_FEATURES_PRODUCT_NEW_GALLERY:
      process.env.NEXT_PUBLIC_FEATURES_PRODUCT_NEW_GALLERY ??
      getConfig(currentEnvironment).NEXT_PUBLIC_FEATURES_PRODUCT_NEW_GALLERY,
  },
  /**
   * Run `build` or `dev` with `SKIP_ENV_VALIDATION` to skip env validation. This is especially
   * useful for Docker builds.
   */
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  /**
   * Makes it so that empty strings are treated as undefined. `SOME_VAR: z.string()` and
   * `SOME_VAR=''` will throw an error.
   */
  emptyStringAsUndefined: true,
});

export const CONTENTFUL_TRADE_PROGRAM_ID = "7yzSxZsnyBqTlaHDeyKhwj";
export const CONTENTFUL_BRAND_PAGE_TEXT_BLOCK_NAME = "Info box brand pages";
